import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-processer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_styled_uploader = _resolveComponent("styled-uploader")!
  const _component_image_processer = _resolveComponent("image-processer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.value)
      ? (_openBlock(), _createBlock(_component_styled_uploader, {
          key: 0,
          onSuccess: _ctx.onImageUploaded
        }, null, 8, ["onSuccess"]))
      : (_openBlock(), _createBlock(_component_image_processer, {
          key: 1,
          value: _ctx.value,
          "show-delete": true,
          onChange: _ctx.handleUploadUrl
        }, null, 8, ["value", "onChange"]))
  ]))
}